import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SedsThemeColorOptions } from '../../shared/enums/index';

@Component({
    selector: 'seds-badge',
    templateUrl: './seds-badge.component.html',
    styleUrls: ['./seds-badge.component.scss'],
    standalone: false
})
export class SedsBadgeComponent implements OnChanges {
  @Input() counter = 0;
  @Input() icon?: string;

  public secondary = SedsThemeColorOptions.SECONDARY;

  public resultCounter?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['counter']) {
      this.limitCounter(changes['counter'].currentValue);
    }
  }

  private limitCounter(counter: number): void {
    if (counter < 0) {
      counter = 0;
      console.warn('Value cannot be negative or less than 0');
    }
    this.resultCounter = counter > 999 ? '999+' : counter.toString();
  }
}
